import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Init from "./common/init";
import utils from "./common/utils";
import constants from "./common/constants";
import "animate.css";
import ElementUI from "element-ui";
import "./assets/css/element-var.scss";
import "./assets/css/index.scss";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

import VueContentmenu from "v-contextmenu"; // 右键菜单
import "v-contextmenu/dist/index.css";
import VueCookies from "vue-cookies";
import md5 from "js-md5";
import axios from "axios";
import VueCropper from "vue-cropper";
import Page from "./components/use/page/Page";
import VueI18n from "vue-i18n";
import GeminiScrollbar from "vue-gemini-scrollbar";
import echarts from "echarts";
import "echarts/theme/macarons.js";
import JsonExcel from "vue-json-excel";
import "./assets/js/china.js";
import filters from "./common/filters";

NProgress.configure({
	easing: "ease", // 动画方式
	speed: 500, // 递增进度条的速度
	showSpinner: false, // 是否显示加载ico
	trickleSpeed: 100, // 自动递增间隔
	minimum: 0.3, // 初始化时的最小百分比
});

Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key]);
});
Vue.prototype.$filters = filters;

Vue.component("downloadExcel", JsonExcel);
Vue.use(ElementUI);
Vue.use(VueContentmenu);
Vue.use(VueCookies);
Vue.use(VueCropper);
Vue.use(VueI18n);
Vue.use(GeminiScrollbar);
const i18n = new VueI18n({
	locale: "zh-CN", // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale
	messages: {
		"zh-CN": require("./common/lang/zh"), // 中文语言包
		"en-US": require("./common/lang/en"), // 英文语言包
	},
});

Vue.component("Page", Page);

Vue.prototype.$echarts = echarts;
Vue.prototype.$md5 = md5;
Vue.prototype.$axios = axios;
Vue.prototype.$init = new Init();
Vue.prototype.$utils = utils;
Vue.prototype.$constants = constants;

function verificationCode(data) {
	var dataObj = data;
	try {
		dataObj = JSON.parse(data);
		if (dataObj.header && dataObj.header.code == "B1001") {
			router.push("/login");
			ElementUI.Message.error("请重新登录");
		}
	} catch {
		if (dataObj.header && dataObj.header.code == "B1001") {
			router.push("/login");
			ElementUI.Message.error("请重新登录");
		}
	}
	return dataObj;
}

Vue.prototype.$http = {
	post(url, data = {}) {
		return axios({
			method: "post",
			baseURL: Vue.prototype.$init.apis.default,
			url: url,
			data: data,
			timeout: 600000,
			headers: {
				token: Vue.prototype.$init.token.accessToken,
			},
			transformResponse: [
				function (data) {
					return verificationCode(data);
				},
			],
		});
	},
	get(url, data = {}) {
		return axios({
			method: "get",
			baseURL: Vue.prototype.$init.apis.default,
			url: url,
			params: data,
			timeout: 600000,
			headers: {
				token: Vue.prototype.$init.token.accessToken,
			},
			transformResponse: [
				function (data) {
					return verificationCode(data);
				},
			],
		});
	},
};

if (VueCookies.get("token")) {
	Vue.prototype.$init.token.accessToken = utils.getCache("token");

	Vue.prototype.$init.userRole = utils.getCache("userRole") || [];

	// 标签存储
	if (window.sessionStorage.getItem("tabs")) {
		store.state.tabs = JSON.parse(window.sessionStorage.getItem("tabs"));
	}

	// 菜单处理
	if (utils.getCache("menus")) {
		Vue.prototype.$init.menu = utils.getCache("menus");
		Vue.prototype.$init.btnIds = utils.getCache("btnIds");
	}
}

// 获得窗口高度
function getTableHeight() {
	function getStyle(obj, attr) {
		if (obj.currentStyle) {
			return obj.currentStyle[attr];
		} else {
			return document.defaultView.getComputedStyle(obj, null)[attr];
		}
	}
	// 获得列表高度
	let listHeight = document.body.clientHeight - 40 - 20;
	store.commit("updateListHeight", listHeight);
	// 设置表格高度
	let headerHeight = 0;
	let footerHeight = 0;
	for (let dom of document.querySelectorAll(".page-list-form")) {
		headerHeight +=
			dom.offsetHeight +
			parseFloat(getStyle(dom, "marginTop")) +
			parseFloat(getStyle(dom, "marginBottom"));
	}
	for (let dom of document.querySelectorAll(".flex-list-footer")) {
		headerHeight +=
			dom.offsetHeight +
			parseFloat(getStyle(dom, "marginTop")) +
			parseFloat(getStyle(dom, "marginBottom"));
	}
	let tableHeight = listHeight - headerHeight - footerHeight;
	store.commit("updateTableHeight", tableHeight);
	store.commit("updateView", document.body.clientWidth > 580);
}

router.beforeEach((to, from, next) => {
	NProgress.start(); // 显示进度条
	if (to.meta.open) {
		next();
	} else if (Vue.prototype.$init.token.accessToken) {
		next();
	} else {
		next("/login");
	}
});
router.afterEach((to, from) => {
	Vue.nextTick(() => {
		getTableHeight();
		store.commit("updateLoader", false);
	});
	NProgress.done();
});

Vue.config.productionTip = false;

new Vue({
	i18n,
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
